import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import { Button } from "react-admin";

const ScmDialogAlert = ({
  mostraDialog,
  sku,
  onClose,
  onUndo,
}: {
  mostraDialog: boolean;
  sku: number;
  onClose: () => void;
  onUndo: () => void;
}) => {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    setShowDialog(mostraDialog);
  }, [mostraDialog]);

  // const handleCloseClick = () => {
  //   setShowDialog(false);
  // };

  const handleCloseClick = () => {
    setShowDialog(false);
    onClose();
  };
  const handleDesfaz = () => {
    onUndo();
  };

  return (
    <>
      <Dialog
        fullWidth
        open={showDialog}
        // onClose={handleCloseClick}
        aria-label="Create post"
        maxWidth="sm"
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseClick();
          }
        }}
      >
        <DialogTitle>Aviso</DialogTitle>
        <DialogContent>
          <Stack display={{ md: "block", lg: "flex" }}>
            <div style={{ color: "red" }}>
              {/* Salvar as alterações para o SKU {sku} antes de continuar? */}
              Há alterações não salvas no SKU {""}
              <span style={{ fontWeight: "bold" }}>{sku}</span>. Clique em
              SALVAR INFO antes de prosseguir.
            </div>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button label="Cancelar" onClick={handleCloseClick} />
          <Button label="Desfazer" onClick={handleDesfaz} />

          {/* continuar sem salvar, salvar */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ScmDialogAlert;
